import { debounce as _debounce } from 'lodash';

import { upsertDrugThreshold } from './index';

export default _debounce(upsertDrugThreshold, 500);
